export default "__VITE_ASSET__CSQyKq8x__"